import React, { useCallback, useEffect, useRef, useState } from 'react';

import { formatMoney } from '../../../util';
import { WalletService } from '../../../services';
import { useToken } from '../../../services/portal';
import './styles.css';
import StateView from '../../ui/StateView';

function Header() {
  const { getToken } = useToken();
  const refSetState = useRef(true);
  const [states, setStates] = useState({
    value: 0,
    error: false,
    loading: false,
  });

  const handleBalance = useCallback(async () => {
    setStates(stt => ({...stt, loading: true }));

    let value = 0;
    let error = false;

    try {
      const token = await getToken();
      const result = await WalletService.getBalance({ token });

      if (result.error) {
        throw new Error(result.msgError);
      }

      value = Number(result.data['amount'] || 0);
    } catch (err) {
      error = true;
    } finally {
      if (refSetState.current) {
        setStates({ loading: false, value, error });
      }
    }
  }, []);

  useEffect(() => {
    refSetState.current = true;

    handleBalance();

    return () => {
      refSetState.current = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <header className="wa-header">
      <div className="wa-container header__content">
        <h1>Carteira</h1>
        <div>
          <StateView
            error={states.error}
            loading={states.loading}
            viewLoading={
              <h1 className="state">Carregando...</h1>
            }
            viewError={
              <h1 className="state">Error</h1>
            }
          >
            <h1>{formatMoney(states.value)}</h1>
          </StateView>
          <p>Saldo atual</p>
        </div>
      </div>
    </header>
  );
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Pages/Wallet/components/functional/Header/index.js